module.exports = __webpack_public_path__ + "static/00014.69e93dcd.jpg";